import axios from "axios";
import { useEffect } from "react";
import { message } from "antd";
import UseTranslate from "./hooks/UseTranslate";

const AxiosConfig = ({ children }) => {
	const [messageApi, contextHolder] = message.useMessage();
	const translate = UseTranslate();

	axios.defaults.baseURL = process.env.REACT_APP_API_URL === undefined ? "https://dev-admin-api.ti-vtb.com" : "https://" + process.env.REACT_APP_API_URL + ".vcb.amc.seoul.kr";
	axios.defaults.headers["X-AUTH-TOKEN"] = `Bearer ${sessionStorage.getItem("token")}`;

	useEffect(() => {
		const resInterceptor = (response) => {
			return response;
		};

		const errInterceptor = (error) => {
			const resMessage = error.response?.data?.message;

			if (resMessage) {
				messageApi.error(resMessage).then();
			}
			return Promise.reject(error);
		};

		const interceptor = axios.interceptors.response.use(resInterceptor, errInterceptor);

		return () => axios.interceptors.response.eject(interceptor);
	}, [messageApi]);
	return (
		<>
			{contextHolder}
			{children}
		</>
	);
};

export default AxiosConfig;
